<app-navbar></app-navbar>
<main class="signup-container">
    <div class="signup-wrapper">
        <!-- Header Section -->
        <div class="signup-header">
            <div class="header-content">
                <h1 class="signup-title">Create Your Account</h1>
                <p class="signup-subtitle">Join Solar Taxi Academy and start learning today</p>
            </div>
        </div>

        <!-- Form Container -->
        <div class="form-container">
            <!-- Tab Navigation -->
            <div class="tab-navigation">
                <button type="button" class="tab-btn login-tab" routerLink="/home">
                    <i class="fa fa-sign-in-alt"></i>
                    <span>Log In</span>
                </button>
                <button type="button" class="tab-btn signup-tab active" routerLink="/signup">
                    <i class="fa fa-user-plus"></i>
                    <span>Sign Up</span>
                </button>
            </div>

            <!-- Form -->
            <form #form="ngForm" (ngSubmit)="onSubmit(form)" class="signup-form">
                <!-- Full Name -->
                <div class="form-group">
                    <label for="fullName" class="form-label">
                        <i class="fa fa-user"></i>
                        Full Name
                    </label>
                    <input 
                        type="text" 
                        placeholder="Enter your full name"
                        ngModel 
                        name="fullName" 
                        class="form-control form-input"
                        id="fullName" 
                        [(ngModel)]="newUser.fullName" 
                        #fullNameField="ngModel"
                        [class.error]="form.submitted && fullNameField.invalid"
                        (blur)="onBlur(fullNameField)" 
                        required>
                    <div class="error-message" [hidden]="!form.submitted || fullNameField.valid">
                        <i class="fa fa-exclamation-circle"></i>
                        Please enter your full name
                    </div>
                </div>

                <!-- Email Address -->
                <div class="form-group">
                    <label for="emailAddress" class="form-label">
                        <i class="fa fa-envelope"></i>
                        Email Address
                    </label>
                    <input 
                        type="email" 
                        placeholder="Enter your email address" 
                        ngModel 
                        name="emailAddress" 
                        class="form-control form-input"
                        id="emailAddress" 
                        [(ngModel)]="newUser.emailAddress" 
                        #emailAddressField="ngModel"
                        [class.error]="form.submitted && emailAddressField.invalid"
                        (blur)="onBlur(emailAddressField)" 
                        required>
                    <div class="error-message" [hidden]="!form.submitted || emailAddressField.valid">
                        <i class="fa fa-exclamation-circle"></i>
                        Please enter a valid email address
                    </div>
                </div>

                <!-- Phone Number -->
                <div class="form-group">
                    <label for="phoneNumber" class="form-label">
                        <i class="fa fa-phone"></i>
                        Phone Number
                    </label>
                    <input 
                        type="tel" 
                        placeholder="Enter your phone number" 
                        ngModel 
                        name="phoneNumber" 
                        class="form-control form-input"
                        id="phoneNumber" 
                        [(ngModel)]="newUser.phoneNumber" 
                        #phoneNumberField="ngModel" 
                        [class.error]="form.submitted && phoneNumberField.invalid"
                        (blur)="onBlur(phoneNumberField)" 
                        required>
                    <div class="error-message" [hidden]="!form.submitted || phoneNumberField.valid">
                        <i class="fa fa-exclamation-circle"></i>
                        Please enter your phone number
                    </div>
                </div>

                <!-- Password -->
                <div class="form-group">
                    <label for="userPwd" class="form-label">
                        <i class="fa fa-lock"></i>
                        Password
                    </label>
                    <div class="password-input-wrapper">
                        <input 
                            [type]="fieldTextType ? 'text' : 'password'" 
                            placeholder="Enter a strong password" 
                            ngModel 
                            name="userPwd" 
                            class="form-control form-input"
                            id="userPwd" 
                            [(ngModel)]="newUser.userPwd" 
                            #userPwdField="ngModel"
                            [class.error]="form.submitted && userPwdField.invalid"
                            (blur)="onBlur(userPwdField)" 
                            required>
                        <button 
                            type="button" 
                            class="password-toggle"
                            (click)="toggleFieldTextType()"
                            tabindex="-1">
                            <i class="fa" [ngClass]="{'fa-eye-slash': !fieldTextType, 'fa-eye': fieldTextType}"></i>
                        </button>
                    </div>
                    <div class="error-message" [hidden]="!form.submitted || userPwdField.valid">
                        <i class="fa fa-exclamation-circle"></i>
                        Please enter a strong password
                    </div>
                </div>

                <!-- Confirm Password -->
                <div class="form-group">
                    <label for="confirmPwd" class="form-label">
                        <i class="fa fa-lock"></i>
                        Confirm Password
                    </label>
                    <div class="password-input-wrapper">
                        <input 
                            [type]="fieldTextType2 ? 'text' : 'password'" 
                            placeholder="Confirm your password" 
                            ngModel 
                            name="confirmPwd" 
                            class="form-control form-input"
                            id="confirmPwd" 
                            [(ngModel)]="newUser.userPwd" 
                            #confirmPwdField="ngModel"
                            [class.error]="form.submitted && confirmPwdField.invalid"
                            (blur)="onBlur(confirmPwdField)" 
                            required>
                        <button 
                            type="button" 
                            class="password-toggle"
                            (click)="toggleFieldTextType2()"
                            tabindex="-1">
                            <i class="fa" [ngClass]="{'fa-eye-slash': !fieldTextType2, 'fa-eye': fieldTextType2}"></i>
                        </button>
                    </div>
                    <div class="error-message" [hidden]="!form.submitted || confirmPwdField.valid">
                        <i class="fa fa-exclamation-circle"></i>
                        Please confirm your password
                    </div>
                </div>

                <!-- Register Button -->
                <button type="submit" class="btn-register">
                    <i class="fa fa-user-check"></i>
                    <span>Create Account</span>
                </button>
            </form>

            <!-- Sign In Link -->
            <div class="signin-link">
                <p>Already have an account? <a routerLink="/home" class="link-text">Sign in here</a></p>
            </div>
        </div>
    </div>
</main>